module.exports = __webpack_public_path__ + "static/media/polygon-matic-logo.1ee4a1ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment/networks/polygon-matic-logo.png
// module id = 430
// module chunks = 7